import React from 'react';
import LoginShowcase from '@/components/LoginShowcase';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col pt-16">
      <Header />
      <main className="flex-1">
        <LoginShowcase />
      </main>
      <Footer />
    </div>
  );
};

export default Index;